import React from 'react';

const DownloadIcon = ({ ...props }) => (
  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.5786 7.17857C12.7572 7 12.7572 6.71429 12.5786 6.57143L11.8643 5.85714C11.7215 5.67857 11.4357 5.67857 11.2572 5.85714L7.90002 9.32143V0.428571C7.90002 0.214286 7.72145 0 7.47145 0H6.47145C6.25717 0 6.04288 0.214286 6.04288 0.428571V9.32143L2.72145 5.85714C2.54288 5.67857 2.25717 5.67857 2.11431 5.85714L1.40002 6.57143C1.22145 6.71429 1.22145 7 1.40002 7.17857L6.68574 12.4643C6.86431 12.6429 7.11431 12.6429 7.29288 12.4643L12.5786 7.17857ZM13.4357 14.1429H0.578596C0.328596 14.1429 0.150024 14.3571 0.150024 14.5714V15.5714C0.150024 15.8214 0.328596 16 0.578596 16H13.4357C13.65 16 13.8643 15.8214 13.8643 15.5714V14.5714C13.8643 14.3571 13.65 14.1429 13.4357 14.1429Z"
      fill="#27ACCD"
    />
  </svg>
);

export default DownloadIcon;
